import { createRoutine } from 'redux-saga-routines';

export const fetchCustomList = createRoutine('FETCH_CUSTOM_LIST');
